<template lang="html">
  <header class="header" :class="{ 'in-builder-mode': inBuilderMode }">
    <Logo :whiteLabel="whiteLabel"/>

    <TrelloAnnouncement/>

    <transition name="fade">
      <div class="top-nav" v-if="loggedIn">
        <div class="user-info" v-if="!inBuilderMode">
          <router-link
            class="company-link"
            :to="{name: 'company-user', params: {companyId: currentUser.company_id, userId: currentUser.id}}">
            <p class="full-name">Good {{timeOfDay}}, <strong>{{firstName}}!</strong></p>
          </router-link>

          <router-link
            class="company-link"
            :to="{name: 'websites', params: {companyId: currentUser.company_id}}">
            <span v-if="currentUser.admin">Admin</span>
          </router-link>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

import Logo from '@/components/Logo'
import TrelloAnnouncement from '@/components/TrelloAnnouncement'

export default {
  name: 'Header',

  props: {
    whiteLabel: Boolean,
    companyId: String,
    siteId: String
  },

  computed: {
    ...mapGetters(['loggedIn']),
    ...mapState(['currentUser']),

    showSiteSubscription() {
      return this.$route.meta.showSubscription
    },

    inBuilderMode() {
      return this.$route.meta.hideSidebar
    },

    timeOfDay() {
      let today = new Date()
      let hr = today.getHours()

      if (hr < 12) {
        return 'morning'
      } else if (hr < 18) {
        return 'afternoon'
      } else {
        return 'evening'
      }
    },

    firstName() {
      let name = this.currentUser.name || ''
      return name.split(' ')[0]
    }
  },

  components: {
    Logo,
    TrelloAnnouncement
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'

.header
  background: #fff
  align-items: center
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)
  display: flex
  justify-content: space-between
  padding: 0 $gap-small
  height: $header-height
  position: relative
  transition: all .2s ease-in-out
  background-image: url('~@/assets/triangles.webp')
  background-size: cover

  &:before
    content: ''
    background: rgba(255, 255, 255, 0.9)
    width: 100%
    height: 100%
    left: 0
    top: 0
    position: absolute
    pointer-events: none
    transition: background .3s ease-in-out

  &.in-builder-mode
    &:before
      background: rgba(50, 50, 50, 0.9)

    .logo
      z-index: 0

  @include media($media-gt-small)
    padding: 0 $gap-medium

  .logo
    text-align: center
    z-index: 2

  .top-nav
    display: flex
    align-items: center
    opacity: 0
    animation: fadeIn .5s 1s
    animation-fill-mode: forwards

    @include media($media-gt-small)
      justify-content: flex-end
      width: 100%

.user-info
  display: none

  @include media($media-gt-small)
    display: block

.full-name, .company-link
  text-transform: uppercase
  text-align: right
  margin: 0

.full-name
  @include themify($themes)
    color: themed('color-primary')

.company-link
  font-size: 9px
  margin-top: -5px
  font-weight: normal
  display: block

  @include themify($themes)
    color: themed('color-secondary')
</style>
